module.exports = __webpack_public_path__ + "img/运营推广.d0c36c5b.svg";